module.exports = "/_next/static/images/Dumitru_Boscanean-9e293647f1aaa6e58d062568c407966a.webp";